import { getToolName, isToolUIPart, type UIMessage } from "ai";

export function settleWriteToolPartWithOutput({
  messages,
  toolCallId,
  isWriteToolName,
  output,
}: {
  messages: UIMessage[];
  toolCallId: string;
  isWriteToolName: (toolName: string) => boolean;
  output: Record<string, unknown>;
}): UIMessage[] {
  if (!toolCallId) return messages;

  let changed = false;
  const next = messages.map((message) => {
    if (message.role !== "assistant") return message;
    let messageChanged = false;
    const parts = message.parts.map((part) => {
      if (!isToolUIPart(part)) return part;
      if (part.toolCallId !== toolCallId) return part;
      if (!isWriteToolName(getToolName(part))) return part;
      messageChanged = true;
      return {
        ...part,
        state: "output-available" as const,
        output,
      } as typeof part;
    });
    if (!messageChanged) return message;
    changed = true;
    return { ...message, parts };
  });

  return changed ? next : messages;
}
